export default __webpack_public_path__ + "static/media/shoppage-package1.0cb75ad2.svg";